import SignIn from './SignIn';

export default function SignUp() {
  return <SignIn newVisitor={true} redirect={'/'} />;
}
